import React, { useMemo, useState } from 'react';
import { TouchableInputProps } from '..';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { ACTION_CTA_CLICK, HOMEPAGE_VIDEO_VISIT_MODULE } from '../../../../core/analytics/events';
import { isClientSide } from '../../../../core/util/system';
import SearchButton from '../SearchButton';
import StateInput from '../StateInput';
import WhenInput from '../WhenInput';
import { RemixRoutes } from '~/core/remix';

/**
 * The search form for a video visit.
 */
const VideoForm = ({ touched }: TouchableInputProps) => {
  const [selectedRegion, setSelectedRegion] = useState('');

  const remixSRP = useMemo(() => {
    return RemixRoutes.search.controlled({
      location: selectedRegion,
      modality: 'telemed',
    });
  }, [selectedRegion]);

  /**
   *
   */
  function search() {
    analyticsTrackEvent(HOMEPAGE_VIDEO_VISIT_MODULE, { action: ACTION_CTA_CLICK });
    if (isClientSide()) {
      window.location.href = remixSRP;
    }
  }
  return (
    <>
      <StateInput onChange={setSelectedRegion} touched={touched} />
      <WhenInput collapseOnMobile />
      <SearchButton disabled={!selectedRegion} onSearch={search} />
    </>
  );
};

export default VideoForm;
